import React from 'react'
import PropTypes from 'prop-types'
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import  { capitalizeFirstLetter }  from '../../_global/js/Utils.js';
import { InfoCircle } from '../../SVGs/svg.imports.js';


const ButtonOptions = (props) => {
    const { matrixData, setOptionSelectionId, checked, setChecked, setShowOptionTooltipModal, setTooltipContent } = useStore(state =>({
        matrixData: state.matrixData,
        setOptionSelectionId: state.setOptionSelectionId,
        checked: state.checked,
        setChecked: state.setChecked,
        setShowOptionTooltipModal: state.setShowOptionTooltipModal,
        setTooltipContent: state.setTooltipContent,
    }), shallow);
    
    const clickOption = (e) => {
        setChecked(e.target.id);
        setOptionSelectionId(e.target.id);
    }

    const focusOption = (e) => {
        const id = e.target.id;
        let optionWrapper = document.getElementById(id).closest('.step_option');
        optionWrapper.classList.add('option-focus');
    }

    const removeFocus = (e) => {
        const id = e.target.id;
        let optionWrapper = document.getElementById(id).closest('.step_option');
        optionWrapper.classList.remove('option-focus'); 
    }

    const openOptionTooltip = (e) => {
        setShowOptionTooltipModal(true);
        const id = e.currentTarget.dataset.id;
        const optionTooltip = matrixData['pages'][id]['option_displayed_on_parent_tooltip'];
        setTooltipContent(optionTooltip);
    }

    let children = matrixData['pages'][props.pageId]['children'];

    if(children.length === 1){
        const onlyOptionId = children[0];
        setChecked(onlyOptionId);
        setOptionSelectionId(onlyOptionId);
    }else{

        let optionsListing;
    
        optionsListing =  children.map((item) => {
            const optionTooltip = matrixData['pages'][item]['option_displayed_on_parent_tooltip'];
            return (
                <div
                    className="step_option decision_box--option step_option--button"
                    key={item}           
                >
                    <label htmlFor={item} className={`step_option-inner ${checked === item ? "highlight": ""}`}>
                        <input type="radio" id={item} name="common" onClick={clickOption} onFocus={focusOption} onBlur={removeFocus} />
                        <div className="option_span">
                            {capitalizeFirstLetter(matrixData['pages'][item]['option_displayed_on_parent'])}
                            {optionTooltip ? <button onClick={openOptionTooltip}className="option_tooltip" data-id={item}><InfoCircle /></button> : ''}
                        </div>
                    </label>
                </div>
            )
        })
        return (
          <div className="step_options step_options--button">
              {optionsListing}
          </div>
        )
    }
  
    
}

ButtonOptions.propTypes = {
    pageId: PropTypes.string
}

export default ButtonOptions